export default (_, { market, t }) => {
  return {
    title: t('changelog', 'changelog.title'),
    description: undefined,
    canonical: `${market.domain}${(market.routes &&
      market.routes.changelogLandingPage &&
      market.routes.changelogLandingPage.path) ||
      '/changelog'}`,
    openGraph: [],
    structuredData: undefined,
    hrefLang: undefined,
  };
};
